import { apiRequest } from '../../services/apiClient';

export function getRequest(requestId) {
  return apiRequest(`/requests/${requestId}`);
}

export function submitRequest(requestId) {
  return apiRequest(`/requests/${requestId}/submit`, {
    method: 'POST',
  });
}

export function withdrawRequest(requestId) {
  return apiRequest(`/requests/${requestId}/withdraw`, {
    method: 'POST',
  });
}

export function reviewRequest(requestId, payload) {
  return apiRequest(`/requests/${requestId}/review`, {
    method: 'POST',
    json: payload,
  });
}

export function rerunFirstPass(requestId) {
  return apiRequest(`/requests/${requestId}/first-pass`, {
    method: 'POST',
  });
}

export function uploadRequestDocument(requestId, formData) {
  return apiRequest(`/requests/${requestId}/documents`, {
    method: 'POST',
    body: formData,
  });
}

export function createContractFromRequest(requestId) {
  return apiRequest(`/requests/${requestId}/create-contract`, {
    method: 'POST',
  });
}

export function deleteRequest(requestId) {
  return apiRequest(`/requests/${requestId}`, {
    method: 'DELETE',
  });
}

export function archiveRequest(requestId) {
  return apiRequest(`/requests/${requestId}/archive`, {
    method: 'POST',
  });
}

export function unarchiveRequest(requestId) {
  return apiRequest(`/requests/${requestId}/unarchive`, {
    method: 'POST',
  });
}
